<template>
  <div
    fluid
    text-center
  >
    <v-alert
      v-model="alerta.mostrar"
      dismissible
      :type="alerta.tipo"
    >
      {{ alerta.mensaje }}
    </v-alert>
    <v-spinner v-if="cargando"></v-spinner>
    <template v-else>
      <el-listado
        v-if="listado.mostrar"
        v-bind="listado"
        v-bind:permiso="permiso"
        v-bind:modelo-api="modeloApi"
        v-bind:combos="combos"
        v-on:verItem="ver"
        v-on:crearItem="crear"
        v-on:verDetalle="verDetalle"
        v-on:verPagos="verPagos"
        v-on:imprimir="imprimirRecibo"
        v-on:mostrarError="mostrarError"
      ></el-listado>
      <v-dialog
        v-model="formulario.mostrar"
        max-width="95%"
        persistent
        scrollable
      >
        <el-formulario
          v-if="formulario.mostrar"
          v-bind="formulario"
          v-bind:permiso="permiso"
          v-bind:modelo-api="modeloApi"
          v-on:alGuardar="alGuardar"
          v-on:alCerrar="alCerrar"
        ></el-formulario>
      </v-dialog>
      <v-dialog
        v-model="detalle.mostrar"
        max-width="100%"
        persistent
        scrollable
      >
        <el-detalle
          v-if="detalle.mostrar"
          v-bind="detalle"
          v-on:alCerrar="alCerrarDetalle"
        ></el-detalle>
      </v-dialog>
      <v-dialog
        v-model="pagos.mostrar"
        max-width="100%"
        persistent
        scrollable
      >
        <medios-pago
          v-if="pagos.mostrar"
          v-bind="pagos"
          v-bind:permiso="permiso"
          v-bind:modelo-api="modeloApi"
          v-on:alCerrar="alCerrarPagos"
        ></medios-pago>
      </v-dialog>
      <div id="imprimirForm">
        <imprimir
          v-bind:item="imprimir.itemSeleccionado"
          v-bind:mostrar="imprimir.mostrar"
        >

          <template
            slot="cabecera"
            slot-scope="itemImprimir"
          >

            Recibo de Cobro N° {{ itemImprimir.id }}<br />DOCUMENTO NO VALIDO COMO
            FACTURA
          </template>
          <template
            slot="contenido"
            slot-scope="itemImprimir"
          >
            <tr>
              <th
                class="tg-desc tg-espacio"
                colspan="5"
              >
                A la orden de:
                <strong>{{ itemImprimir.emitido_obra_social.nombre }}</strong>
                <br />
                Concepto:
                <strong> {{ itemImprimir.concepto }}</strong>
                <br />
                Fecha Emisión:
                <strong> {{ itemImprimir.fecha | formatoFecha }}</strong>
                <br />
                Estado:
                <strong> {{ itemImprimir.estado.nombre }}</strong>
                <br />
              </th>
            </tr>

            <tr>
              <td
                class="tg-9apd tg-key"
                colspan="5"
              >Comprobantes cancelados</td>
            </tr>
            <tr>
              <td class="tg-0lax tg-key">Fecha</td>
              <td class="tg-0lax tg-key">Cod.</td>
              <td class="tg-0lax tg-key">N°</td>
              <td class="tg-0lax tg-key">Concepto</td>
              <td class="tg-0lax tg-key txt-right">A Pagar</td>
            </tr>
            <tr
              v-for="item in itemImprimir.comprobantes"
              :key="item.id"
            >
              <td class="tg-0lax">{{ item.comprobante.fecha | formatoFecha }}</td>
              <td class="tg-0lax">{{ item.comprobante.tipo_comprobante.codigo }}</td>
              <td class="tg-0lax">{{ item.comprobante.numero_comprobante }}</td>
              <td class="tg-0lax">{{ item.comprobante.concepto_descripcion }}</td>
              <td class="tg-0lax txt-right">
                <template v-if="item.comprobante.tipo_comprobante.codigo === 'FC'">
                  {{ item.importe | currency }}
                </template>
                <template v-else> ( {{ item.importe | currency }} ) </template>
              </td>
            </tr>
            <tr>
              <td
                class="tg-9apd tg-key txt-right"
                colspan="4"
              >Total Comprobantes Cancelados:</td>
              <td
                class="tg-9apd tg-key txt-right"
                colspan="1"
              >
                {{ itemImprimir.importe | currency }}
              </td>
            </tr>
            <tr>
              <td
                class=""
                colspan="5"
              ></td>
            </tr>
            <tr>
              <td
                class="tg-9apd tg-key"
                colspan="5"
              >Medios de Cancelación</td>
            </tr>
            <tr>
              <td class="tg-0lax tg-key">Fecha</td>
              <td class="tg-0lax tg-key">Medio</td>
              <td
                class="tg-0lax tg-key"
                colspan="2"
              >Concepto</td>
              <td class="tg-0lax tg-key txt-right">Importe</td>
            </tr>
            <tr
              v-for="item in itemImprimir.pagos"
              :key="item.id"
            >
              <td class="tg-0lax">{{ item.fecha | formatoFecha }}</td>
              <td class="tg-0lax">{{ item.tipo_pago.nombre }}</td>
              <td
                class="tg-0lax"
                colspan="2"
              >{{ item.descripcion }}</td>
              <td class="tg-0lax txt-right">{{ item.importe | currency }}</td>
            </tr>
            <tr>
              <td
                class="tg-9apd tg-key txt-right"
                colspan="4"
              >Total Medios de Cobro:</td>
              <td
                class="tg-9apd tg-key txt-right"
                colspan="1"
              >
                {{ itemImprimir.importePagos | currency }}
              </td>
            </tr>
            <tr>
              <td
                class=""
                colspan="5"
              ></td>
            </tr>
            <tr>
              <td
                class="tg-9apd txt-right tg-key"
                colspan="5"
              >Recibo</td>
            </tr>
            <tr>
              <td
                class="tg-0lax"
                colspan="5"
              >
                <p class="txt-right">Capital Federal, __ de ___________ de 20__</p>
                <br />
                <p>
                  Recibimos de {{ itemImprimir.emitido_obra_social.nombre }}, la cantidad
                  de pesos _________________________________________ por los conceptos arriba
                  indicados a nuestra entera satisfacción.
                </p>
                <br />
                <p class="txt-right">
                  <span class="txt-center firma">
                    _________________ <br />
                    Firma</span>
                </p>
              </td>
            </tr>
            <tr>
              <td
                class=""
                colspan="5"
              ></td>
            </tr>
            <tr>
              <td
                class="tg-9apd txt-right tg-key"
                colspan="5"
              >Firmas</td>
            </tr>
            <tr>
              <td
                class="tg-0lax"
                colspan="5"
              >
                <span class="tg-key item-firma">Confeccionó:</span>
                <span class="tg-key item-firma">Autorizó:</span>
                <span class="tg-key item-firma">Efectivizó:</span>
              </td>
            </tr>
          </template>
        </imprimir>
      </div>
    </template>
  </div>
</template>

<script>
import EventBus from '@/helpers/eventBus'
import mixinAbm from '@/mixins/abm'
import ElListado from '../components/ReciboListado'
import ElFormulario from '../components/ReciboFormulario'
import ElDetalle from '../components/ReciboDetalleComprobante'
import MediosPago from '../components/ReciboPagos'
import Imprimir from '@/components/Imprimir/Imprimir'
import Modelo from '@/api/recibo'
import _ from 'lodash'
import { fechaLocal, formatoFecha } from '@/helpers/filtros'

import Combo from '@/api/combo'
export default {
  mixins: [mixinAbm],
  filters: { formatoFecha },
  components: {
    ElListado,
    ElFormulario,
    ElDetalle,
    MediosPago,
    Imprimir
  },
  props: {
    soloLectura: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      montarMixin: false,
      combos: {
        valoresSiNo: [
          { valor: null, nombre: 'Seleccione' },
          { valor: true, nombre: 'Si' },
          { valor: false, nombre: 'No' }
        ]
      },
      cargando: true,
      permiso: 'tesoreria_recibos',
      modeloApi: Modelo,
      listado: {
        mostrar: false,
        referencia: 'recibosListado'
      },
      detalle: {
        mostrar: false,
        titulo: 'Detalle'
      },
      pagos: {
        mostrar: false,
        titulo: 'Pagos'
      },
      imprimir: {
        cargando: false,
        itemSeleccionado: null,
        mostrar: false
      }
    }
  },
  mounted () {
    this.cargarFiltros()
  },
  methods: {
    crear () {
      this.formulario = _.assign(this.formulario, {
        operacion: 'alta',
        titulo: 'Alta',
        item: {
          id: 0,
          emitido_por_obra_social_id: null,
          emitido_obra_social: {
            id: null,
            codigo: null
          },
          estado_id: null,
          estado: {
            codigo: 'abierto'
          },
          numero: null,
          fecha: fechaLocal('YYYY-MM-DD'),
          importe: 0
        },
        mostrar: true
      })
    },
    ver (item) {
      this.formulario = _.assign(this.formulario, {
        operacion: 'lectura',
        titulo: 'Ver',
        item: item,
        mostrar: true
      })
    },
    cargarDatos (id) {
      let vm = this
      if (id) {
        this.modeloApi.obtener(id).then(
          data => {
            this.formulario = _.assign(this.formulario, {
              operacion: this.soloLectura ? 'lectura' : 'modif',
              titulo: this.soloLectura ? 'Ver' : 'Editar',
              item: data,
              mostrar: true
            })
          },
          error => {
            vm.mostrarError(error)
          }
        )
      }
    },
    alGuardar (item) {
      this.filtrarListado()
      this.alCerrar()
    },
    alCerrar () {
      this.formulario.mostrar = false
    },
    filtrarListado (origen) {
      this.ocultarAlerta()
      EventBus.$emit(this.listado.referencia + ':filtrar')
    },
    cargarFiltros () {
      let vm = this

      let dataCombos = {
        comprobanteEstados: {
          itemVacio: true,
          tipo: 'P'
        },
        obrasSociales: {
          relaciones: ['planes'],
          itemVacio: 'Seleccione'
        }
      }
      Combo.listado(dataCombos).then(
        data => {
          vm.combos = _.assign(vm.combos, data)
          vm.cargando = false
          vm.listado.mostrar = true
        },
        error => {
          vm.mostrarError(error)
          vm.cargando = false
        }
      )
    },
    verDetalle (item) {
      this.detalle = _.assign(this.detalle, {
        reciboId: item.id,
        mostrar: true
      })
    },
    alCerrarDetalle () {
      this.detalle.mostrar = false
    },
    verPagos (item) {
      this.pagos = _.assign(this.pagos, {
        reciboId: item.id,
        mostrar: true
      })
    },
    alCerrarPagos () {
      this.filtrarListado()
      this.pagos.mostrar = false
    },
    imprimirRecibo (item) {
      let vm = this
      vm.imprimir.cargando = true
      vm.modeloApi.obtener(item.id).then(
        data => {
          let importeMediosPago = 0
          _.forEach(data.pagos, item => {
            importeMediosPago += Number(item.importe)
          })
          data.importePagos = String(importeMediosPago.toFixed(2)).replace(',', '.')
          vm.imprimir.itemSeleccionado = data
          vm.imprimir.mostrar = true
          vm.imprimir.cargando = false

          this.$nextTick(() => {
            let prtHtml = document.getElementById('imprimirForm').innerHTML
            vm.imprimir.mostrar = false
            prtHtml = prtHtml.replace('display: none', '')

            let stylesHtml = ''
            for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
              stylesHtml += node.outerHTML
            }

            // Open the print window
            const WinPrint = window.open(
              '',
              '',
              'left=40px,top=40px,width=750,height=600,toolbar=0,scrollbars=0,status=0'
            )

            WinPrint.document.write(`<!DOCTYPE html>
              <html>
                <head>
                  ${stylesHtml}
                </head>
                <body style="padding: 20px">
                  ${prtHtml}
                </body>
              </html>`)

            WinPrint.document.close()
            WinPrint.focus()
          })
        },
        error => {
          vm.imprimir.cargando = false
          vm.mostrarError(error)
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
